<atn-ds-page>
  <atn-ds-page-header
    pageHeader
    [name]="scenarioNameSg()"
    [breadcrumbs]="breadcrumbsSg()"
  />
  <atn-ds-floating-horizontal-tabs>
    <ng-template
      atnDsTab
      name="General"
    >
      <atn-admin-scenario-page-general-tab />
    </ng-template>

    @if (canManageUsersSg()) {
      <ng-template
        atnDsTab
        name="Users"
      >
        <atn-admin-scenario-page-users-tab />
      </ng-template>
    }
  </atn-ds-floating-horizontal-tabs>
</atn-ds-page>
